import type { ReactElement } from "react";

import { MoveChatDialog } from "./move-chat-dialog";
import { RenameChatDialog } from "./rename-chat-dialog";
import ConfirmationDialog from "~/shared/ui/confirm-dialog";

type Translate = (key: string) => string;

interface ChatActionsDialogsProps {
    chatId: string;
    workspaceId: string;
    chatTitle: string | null;
    projectId?: string | null;
    sceneId?: string | null;
    renameOpen: boolean;
    onRenameOpenChange: (open: boolean) => void;
    moveOpen: boolean;
    onMoveOpenChange: (open: boolean) => void;
    deleteOpen: boolean;
    onDeleteOpenChange: (open: boolean) => void;
    onConfirmDelete: () => Promise<void>;
    deletePending: boolean;
    t: Translate;
}

/**
 * Презентационная обёртка над тремя диалогами действий с чатом
 * (rename / move / delete). Стейт open/onOpenChange живёт в `useChatActions`
 * (его дёргают `onSelect` пунктов меню) — сюда приходит готовыми props'ами.
 */
export function ChatActionsDialogs({
    chatId,
    workspaceId,
    chatTitle,
    projectId,
    sceneId,
    renameOpen,
    onRenameOpenChange,
    moveOpen,
    onMoveOpenChange,
    deleteOpen,
    onDeleteOpenChange,
    onConfirmDelete,
    deletePending,
    t,
}: ChatActionsDialogsProps): ReactElement {
    return (
        <>
            <RenameChatDialog
                open={renameOpen}
                onOpenChange={onRenameOpenChange}
                chatId={chatId}
                workspaceId={workspaceId}
                currentTitle={chatTitle && chatTitle.length > 0 ? chatTitle : t("untitledChat")}
            />
            <MoveChatDialog
                open={moveOpen}
                onOpenChange={onMoveOpenChange}
                chatId={chatId}
                workspaceId={workspaceId}
                projectId={projectId}
                sceneId={sceneId}
            />
            <ConfirmationDialog
                isOpen={deleteOpen}
                onClose={() => onDeleteOpenChange(false)}
                onConfirm={onConfirmDelete}
                title={t("header.deleteDialog.title")}
                description={t("header.deleteDialog.description")}
                confirmText={t("header.deleteDialog.delete")}
                cancelText={t("header.deleteDialog.cancel")}
                waitConfirm={deletePending}
            />
        </>
    );
}
